<template>
    <div class="border-t-8 border-highlight bg-white mb-8 relative shadow z-40">
        <div class="lg:container mx-auto px-4">
            <div class="flex justify-between items-center py-4">
                <div class="lg:hidden">
                    <a class="cursor-pointer flex flex-col justify-center h-5 w-6"
                       v-on:click="showMenu = !showMenu"
                    >
                        <span class="after:absolute after:bg-slate-800 after:block after:content-[''] after:h-0.5 after:origin-top-left after:-top-2 after:transition-all after:w-6 before:absolute before:bg-slate-800 before:block before:content-[''] before:h-0.5 before:origin-bottom-left before:top-2 before:transition-all before:w-6 bg-slate-800 block h-0.5 relative w-6"
                              v-bind:class="{ 'after:rotate-45 before:mt-px before:-rotate-45 !bg-transparent' : showMenu }"
                        ></span>
                    </a>

                    <nav class="absolute bg-highlight flex flex-col h-[calc(100vh-5.5rem)] left-0 p-4 top-20 w-screen z-20"
                         v-if="showMenu"
                    >
                        <router-link class="font-serif hover:underline mb-4 text-2xl text-white"
                                     v-bind:class="{ '!border-highlight' : $route.name && $route.name.startsWith('order.previous') }"
                                     v-bind:to="{ name: 'order.previous' }"
                                     v-if="sessionStore.user && sessionStore.user.role !== 'admin' && sessionStore.user.role !== 'shop'"
                                     v-on:click="showMenu = false"
                        >
                            {{ __('Korábbi rendeléseim') }}
                        </router-link>

                        <router-link class="font-serif hover:underline mb-4 text-2xl text-white"
                                     v-bind:to="{ name: 'orders.table' }"
                                     v-if="sessionStore.user && sessionStore.user.role === 'admin'"
                                     v-on:click="showMenu = false"
                        >
                            {{ __('Rendelések') }}
                        </router-link>

                        <router-link class="font-serif hover:underline mb-4 text-2xl text-white"
                                     v-bind:to="{ name: 'products' }"
                                     v-if="sessionStore.user && sessionStore.user.role === 'admin'"
                                     v-on:click="showMenu = false"
                        >
                            {{ __('Termékek') }}
                        </router-link>

                        <router-link class="font-serif hover:underline mb-4 text-2xl text-white"
                                     v-bind:to="{ name: 'products.availability' }"
                                     v-if="sessionStore.user && sessionStore.user.role === 'admin'"
                                     v-on:click="showMenu = false"
                        >
                            {{ __('Tervezés') }}
                        </router-link>

                        <router-link class="font-serif hover:underline mb-4 text-2xl text-white"
                                     v-bind:to="{ name: 'products.base' }"
                                     v-if="sessionStore.user && sessionStore.user.role === 'admin'"
                                     v-on:click="showMenu = false"
                        >
                            {{ __('Alapterv') }}
                        </router-link>

                        <router-link class="font-serif hover:underline mb-4 text-2xl text-white"
                                     v-bind:to="{ name: 'payments' }"
                                     v-if="sessionStore.user && sessionStore.user.role === 'admin'"
                                     v-on:click="showMenu = false"
                        >
                            {{ __('Tranzakciók') }}
                        </router-link>


                        <router-link class="font-serif hover:underline mb-4 text-2xl text-white"
                                     v-bind:to="{ name: 'users' }"
                                     v-if="sessionStore.user && sessionStore.user.role === 'admin'"
                                     v-on:click="showMenu = false"
                        >
                            {{ __('Felhasználók') }}
                        </router-link>

                        <router-link class="font-serif hover:underline mb-4 text-2xl text-white"
                                     v-bind:to="{ name: 'users.groups' }"
                                     v-if="sessionStore.user && sessionStore.user.role === 'admin'"
                                     v-on:click="showMenu = false"
                        >
                            {{ __('Felhasználó csoportok') }}
                        </router-link>

                        <router-link class="font-serif hover:underline mb-4 text-2xl text-white"
                                     v-bind:to="{ name: 'admin.settings' }"
                                     v-if="sessionStore.user && sessionStore.user.role === 'admin'"
                                     v-on:click="showMenu = false"
                        >
                            {{ __('Beállítások') }}
                        </router-link>
<!--                        <router-link class="font-serif hover:underline mb-4 text-2xl text-white"-->
<!--                                     v-bind:to="{ name: 'campaigns' }"-->
<!--                                     v-if="sessionStore.user && sessionStore.user.role === 'admin'"-->
<!--                                     v-on:click="showMenu = false"-->
<!--                        >-->
<!--                            {{ __('Kampányok') }}-->
<!--                        </router-link>-->

                        <router-link class="font-serif hover:underline mb-4 text-2xl text-white"
                                     v-bind:to="{ name: 'order' }"
                                     v-on:click="showMenu = false"
                        >
                            {{ __('Rendelés') }}
                        </router-link>

                        <!--
                        <div class="text-2xl text-white">
                            <a class="font-bold hover:underline">HU</a> | <a class="hover:underline">EN</a>
                        </div>
                        -->

                        <img class="absolute bottom-0 pointer-events-none right-0 max-w-[50vh]" src="/img/bg-poppy.png" />
                    </nav>
                </div>

                <router-link class="lg:w-auto w-1/3" to="/">
                    <img class="h-12" src="/img/logo.png" v-bind:alt="app.name" />
                </router-link>

                <nav class="flex items-center text-sm">
                    <router-link class="border-b-4 border-slate-800 hidden lg:block mr-4 py-2 transition-colors text-slate-800"
                                 v-bind:class="{ '!border-highlight' : $route.name && $route.name.startsWith('order.previous') }"
                                 v-if="sessionStore.user && sessionStore.user.role !== 'admin' && sessionStore.user.role !== 'shop'"
                                 v-bind:to="{ name: 'order.previous' }"
                    >
                        {{ __('Korábbi rendeléseim') }}
                    </router-link>

                    <router-link class="border-b-4 border-slate-800 hidden lg:block mr-4 py-2 transition-colors text-slate-800"
                                 v-bind:class="{ '!border-highlight' : $route.name && $route.name.startsWith('orders') }"
                                 v-if="sessionStore.user && (sessionStore.user.role === 'admin' || sessionStore.user.role === 'shop')"
                                 v-bind:to="{ name: 'orders.table' }"
                    >
                        {{ __('Rendelések') }}
                    </router-link>

                    <div class="cursor-pointer group has-submenu hidden lg:block mr-4 relative"
                         v-if="sessionStore.user && sessionStore.user.role === 'admin'"
                         v-on:click="showSubmenu = 'products'"
                         v-on-click-outside="closeSubmenu"
                    >
                        <a class="after:border-t-4 after:border-t-slate-800 after:border-x-4 after:border-x-transparent after:content-[''] after:ml-2 border-b-4 border-slate-800 flex group-hover:border-slate-800 items-center pointer-events-none py-2 text-slate-800"
                           v-bind:class="{ '!border-highlight' : $route.name && $route.name.startsWith('products') }"
                        >
                            {{ __('Termékek') }}
                        </a>
                        <nav class="absolute bg-white border-t-4 border-t-slate-800 flex flex-col min-w-48 -mt-1 shadow"
                             v-bind:class="{ '!border-t-highlight' : $route.name && $route.name.startsWith('products') }"
                             v-if="showSubmenu === 'products'"
                        >
                            <router-link class="border-b border-b-slate-100 hover:bg-slate-50 p-2 transition-colors text-slate-800"
                                         v-bind:to="{ name: 'products' }"
                            >
                                {{ __('Termékek') }}
                            </router-link>
                            <router-link class="border-b border-b-slate-100 hover:bg-slate-50 p-2 transition-colors text-slate-800"
                                         v-bind:to="{ name: 'products.availability' }"
                            >
                                {{ __('Tervezés') }}
                            </router-link>
                            <router-link class="border-b border-b-slate-100 hover:bg-slate-50 p-2 transition-colors text-slate-800"
                                         v-bind:to="{ name: 'products.base' }"
                            >
                                {{ __('Alapterv') }}
                            </router-link>
                        </nav>
                    </div>

                    <router-link class="border-b-4 border-slate-800 hidden lg:block mr-4 py-2 transition-colors text-slate-800"
                                 v-bind:class="{ '!border-highlight' : $route.name && $route.name.startsWith('payments') }"
                                 v-if="sessionStore.user && sessionStore.user.role === 'admin'"
                                 v-bind:to="{ name: 'payments' }"
                    >
                        {{ __('Tranzakciók') }}
                    </router-link>

<!--                    <router-link class="border-b-4 border-slate-800 hidden lg:block mr-4 py-2 transition-colors text-slate-800"-->
<!--                                 v-bind:class="{ '!border-highlight' : $route.name && $route.name.startsWith('campaigns') }"-->
<!--                                 v-if="sessionStore.user && sessionStore.user.role === 'admin'"-->
<!--                                 v-bind:to="{ name: 'campaigns' }"-->
<!--                    >-->
<!--                        {{ __('Kampányok') }}-->
<!--                    </router-link>-->

                    <div class="cursor-pointer group has-submenu hidden lg:block mr-4 relative"
                         v-if="sessionStore.user && sessionStore.user.role === 'admin'"
                         v-on:click="showSubmenu = 'users'"
                         v-on-click-outside="closeSubmenu"
                    >
                        <a class="after:border-t-4 after:border-t-slate-800 after:border-x-4 after:border-x-transparent after:content-[''] after:ml-2 border-b-4 border-slate-800 flex group-hover:border-slate-800 items-center pointer-events-none py-2 text-slate-800"
                           v-bind:class="{ '!border-highlight' : $route.name && $route.name.startsWith('users') }"
                        >
                            {{ __('Felhasználók') }}
                        </a>
                        <nav class="absolute bg-white border-t-4 border-t-slate-800 flex flex-col min-w-48 -mt-1 shadow"
                             v-bind:class="{ '!border-t-highlight' : $route.name && $route.name.startsWith('users') }"
                             v-if="showSubmenu === 'users'"
                        >
                            <router-link class="border-b border-b-slate-100 hover:bg-slate-50 p-2 transition-colors text-slate-800"
                                         v-bind:to="{ name: 'users' }"
                            >
                                {{ __('Felhasználók') }}
                            </router-link>
                            <router-link class="border-b border-b-slate-100 hover:bg-slate-50 p-2 transition-colors text-slate-800"
                                         v-bind:to="{ name: 'users.groups' }"
                            >
                                {{ __('Felhasználó csoportok') }}
                            </router-link>
                        </nav>
                    </div>
                    <router-link class="border-b-4 border-slate-800 hidden lg:block mr-4 py-2 transition-colors text-slate-800"
                                 v-bind:class="{ '!border-highlight' : $route.name && $route.name.startsWith('admin.settings') }"
                                 v-if="sessionStore.user && sessionStore.user.role === 'admin'"
                                 v-bind:to="{ name: 'admin.settings' }"
                    >
                        {{ __('Beállítások') }}
                    </router-link>

                    <router-link class="bg-highlight font-bold hidden lg:block mr-8 p-2.5 rounded transition-colors text-white"
                                 v-bind:to="{ name: 'order' }"
                    >
                        {{ __('Rendelés') }}
                    </router-link>

                    <router-link class="mr-4" v-if="sessionStore.user"
                                 v-bind:to="{ name: 'order' }"
                    >
                        <img class="h-8" src="/img/icon-cart.svg" />
                    </router-link>

                    <div class="cursor-pointer flex has-submenu items-center relative"
                         v-if="sessionStore.user"
                         v-on:click="showSubmenu = showSubmenu === 'profile' ? '' : 'profile'"
                         v-on-click-outside="closeSubmenu"
                    >
                        <img class="h-8 mr-2" src="/img/icon-user.svg" />

                        <strong class="font-semibold">
                            <span class="mr-1 uppercase">{{ sessionStore.user.lastname }}</span>
                            <span>{{ sessionStore.user.firstname }}</span>
                        </strong>

                        <nav class="absolute bg-white border-t-4 border-t-slate-800 flex flex-col min-w-48 mt-2 right-0 shadow top-full"
                             v-if="showSubmenu === 'profile'"
                        >
                            <router-link class="border-b border-b-slate-100 hover:bg-slate-50 p-2 transition-colors text-slate-800"
                                         v-bind:to="{ name: 'profile' }">
                                {{ __('Adataim') }}
                            </router-link>
                            <a class="border-b border-b-slate-100 hover:bg-slate-50 p-2 transition-colors text-slate-800"
                               v-on:click="sessionStore.logUserOut"
                            >
                                {{ __('Kijelentkezés') }}
                            </a>
                        </nav>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, watch } from 'vue';
    import { vOnClickOutside } from '@vueuse/components';
    import { useSessionStore } from '../stores/session';

    const sessionStore = useSessionStore();
    const showMenu = ref<boolean>(false);
    const showSubmenu = ref('');

    function closeSubmenu() {
        showSubmenu.value = '';
    }

    // Watch for changes to showMenu and toggle body/html scrolling
    watch(showMenu, (isOpen) => {
        if (isOpen) {
            // Disable scrolling on body and html
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
        } else {
            // Re-enable scrolling
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        }
    });
</script>
